module.exports = __webpack_public_path__ + "img/guide_bg.e96806a4.png";